<template>
  <div class="pt80">
    <div class="container1200">
      <Navbar />
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">Página Inicial</el-breadcrumb-item>
        <el-breadcrumb-item>Carrinho de Compras</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="cart-box">
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="list">
              <div class="item" v-for="item in list" :key="item.id">
                <el-image :src="item.goods_image || ''" style="width: 100px;height: 100px;"></el-image>
                <div class="info">
                  <div class="title">{{item.goods_name}}</div>
                  <div class="sku" v-if="item.spec_name">COR: {{item.spec_name}}</div>
                </div>
                <div class="price">
                  <div class="unit">R$ {{item.spec_price}}</div>
                  <div class="num">
                    <el-input-number size="small" :min="1" v-model="item.nums" @change="e=>changeCartNum(e,item)"></el-input-number>
                  </div>
                  <div class="item-total">R$ {{item.spec_price * item.nums}}</div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="checkout">
              <div class="left">
                <el-checkbox-group v-model="checkAll" @change="allCheck">
                  <el-checkbox label="Selecionar tudo" name="checkAll" shape="circle"></el-checkbox>
                </el-checkbox-group>
                <div class="total">
                  <span class="num">R$ {{totalPrice}}</span>
                </div>
              </div>
              <div class="right">
                <el-button type="main" @click="createOrder">
                  <span>Faça um pedido.({{checked}})</span>
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { categoryDetail } from '@/api/home'
import { delCart, listCart, switchItem, swtichAll, setCartNum } from '@/api/cart'
import { createOrder } from '@/api/order'

export default {
  name: 'Cart',
  components: {
    Navbar
  },
  data() {
    return {
      checked: 0,
			totalPrice: 0,
			list: [],
			checkAll: [],
      hasMore: false,
      query: {},
      total: 0,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    goToDetail(item){
      this.$router.push({
        path: '/product/' + item.goods_id,
      })

    },
    changeCartNum(e,item){
      setCartNum({id: item.id,num: e}).catch(err=>{
        console.log('err',err)
      })
    },
    getList(){
      listCart().then(res => {
        console.log('getProductList',res)

          this.list  = res.data.list;
          this.list = res.data.list;
					this.totalPrice = res.data.totalPrice;
					this.total = res.data.total;
					this.checked = res.data.checked;
					if(res.data.checkAll){
						this.checkAll = ['Selecionar tudo'];
					}else{
						this.checkAll = [];
					}
          console.log('this.checkAll',this.checkAll)
      }).catch(err=>{
        console.log('err',err)
      })

    },
    createOrder(){
      if(this.checked <= 0){
					return this.$message.error('Por favor selecione os produtos antes de finalizar a compra');
			}
      const data = {}
      data.buyType = 2;
      const cids = [];
      // console.log('list',this.list);
      this.list.map(item=>{
        if(item.spec_check){
          cids.push(item.id)
        }
      })
      // const {  buyType, goods_id, spec_id, num } = this;
      // console.log("cids",cids);return;
      data.cids = cids.join(',');
      createOrder(data).then(res=>{
        //跳转到订单详情
        this.$router.push({
          name: 'OrderDetail',
          query: {
            id: res.data.order_id
          }

        })

      }).catch(err=>{
        console.log('err',err)
      })

    },

    goSettle(){
				if(this.checked <= 0){
					return this.$message.error('Por favor selecione os produtos antes de finalizar a compra');
				}

				let ids = [];
				this.list.map(item=>{
					if(item.spec_check){
						ids.push(item.id)
					}
				})
				console.log("ids",ids);
        this.$router.push('/settle?cids=' + ids.join(','))

				// uni.navigateTo({
				// 	 url: "/pages/shop/order_confirm?type=2&cids=" + ids.join(",")
				// })
			},
			numChange(value,item,index){
        // console.log('numChange e',e)
        setCartNum({id: item.id,num: value}).then(res=>{
          this.getList();
        }).catch(err=>{
        console.log('err',err)
      })

			},
			buttonDel(item){
        delCart({id: item.id}).then(res=>{
          this.getList();
				}).catch(err=>{
        console.log('err',err)
      })
			},
			allCheck(e){
        console.log('e',e)
				let status = 0;
				if(e.length > 0){
					status = 1;
				}
        swtichAll({status}).then(res=>{
          this.getList();
        }).catch(err=>{
        console.log('err',err)
      })
			},
			switchChecked(item){
        switchItem({id: item.id, status: item.spec_check ? 0 : 1}).then(res=>{
          this.getList();
        }).catch(err=>{
        console.log('err',err)
      })
			},
  }
}
</script>

<style lang="scss" scoped>
.list{
  .item{
    display: flex;
    .info{
      margin-left: 15px;
      .title{
        font-size: 14px;
      }
      .sku{
        font-size: 14px;
      }
    }
    .price{
      display: flex;
      align-items: center;
      .unit{
        margin-left: 15px;
        white-space: nowrap;
      }
      .num{
        margin-left: 15px;
      }
      .item-total{
        margin-left: 15px;
        white-space: nowrap;
      }
    }
  }
}
.checkout{
  background: #f5f5f5;
  padding: 20px;
}
</style>
